"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookBonusResult = void 0;
var BookBonusResult;
(function (BookBonusResult) {
    BookBonusResult[BookBonusResult["Unknown"] = 0] = "Unknown";
    BookBonusResult[BookBonusResult["BonusNotFound"] = 2] = "BonusNotFound";
    BookBonusResult[BookBonusResult["BonusRejected"] = 3] = "BonusRejected";
    BookBonusResult[BookBonusResult["BonusConsumed"] = 4] = "BonusConsumed";
    BookBonusResult[BookBonusResult["BonusAlreadyConsumed"] = 5] = "BonusAlreadyConsumed";
    BookBonusResult[BookBonusResult["BonusAlreadyRejected"] = 6] = "BonusAlreadyRejected";
    BookBonusResult[BookBonusResult["CampaignNotFound"] = 7] = "CampaignNotFound";
    BookBonusResult[BookBonusResult["CampaignExpired"] = 8] = "CampaignExpired";
    BookBonusResult[BookBonusResult["BookingFailed"] = 9] = "BookingFailed";
    BookBonusResult[BookBonusResult["BonusExpired"] = 10] = "BonusExpired";
    BookBonusResult[BookBonusResult["BonusAlreadyCancelled"] = 11] = "BonusAlreadyCancelled";
    BookBonusResult[BookBonusResult["UnexpectedError"] = 99] = "UnexpectedError";
})(BookBonusResult = exports.BookBonusResult || (exports.BookBonusResult = {}));
